import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

/*
路由跳转报错解决方法:https://blog.csdn.net/luer_LJS/article/details/108362563
*/
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
	{
		path: "/",
		redirect: "/welcome"
	},
	{
		path: '/:project_code/welcome',
		name: 'Welcome',
		component: () => import(/* webpackChunkName: "welcome" */ '../views/welcome.vue'),
		meta: {
			title: "欢迎页",
			login: false,
		}
	},
	{
		path: '/:project_code/index',
		name: 'Index',
		component: () => import(/* webpackChunkName: "Index" */ '../views/index.vue'),
		meta: {
			title: "首页",
			login: false,
		}
	},
	{
		path: '/:project_code/login/:subject_code',
		name: 'Login',
		component: () => import(/* webpackChunkName: "login" */ '../views/login.vue'),
		meta: {
			title: "登录",
			login: false,
		}
	},
	{
		path:"/:project_code/test",
		name:"Test",
		component:()=>import(/* webpackChunkName:"test" */ '../views/test.vue'),
		meta:{
			title:"输入法测试",
			login:true
		}
	},
	{
		path: '/:project_code/message',
		name: 'Message',
		component: () => import(/* webpackChunkName: "Message" */ '../views/message.vue'),
		meta: {
			title: "信息确认",
			login: true,
		}
	},
	{
		path: '/:project_code/article',
		name: 'Article',
		component: () => import(/* webpackChunkName: "article" */ '../views/article.vue'),
		meta: {
			title: "考场规则阅读",
			login: true,
		}
	},
	{
		path: '/:project_code/exam',
		name: 'Exam',
		component: () => import(/* webpackChunkName: "exam" */ '../views/exam.vue'),
		meta: {
			title: "考试",
			login: true,
		}
	},
	{
		path: '/:project_code/next',
		name: 'Next',
		component: () => import(/* webpackChunkName: "next" */ '../views/next.vue'),
		meta: {
			title: "两科两考下一科目",
			login: true,
		}
	},
	{
		path: '/:project_code/success',
		name: 'Success',
		component: () => import(/* webpackChunkName: "success" */ '../views/success.vue'),
		meta: {
			title: "考试",
			login: false,
		}
	},

]










const router = new VueRouter({
	routes
})

const whiteList=['Login','Index'];















router.beforeEach((to, from, next) => {
	document.title=store.state.project.project_name?store.state.project.project_name+'电子化考试模拟作答系统' : '电子化考试模拟作答系统';
	if(whiteList.indexOf(to.name)>-1 || !to.meta.login){
		//白名单
		next();
	}else if (!store.state.user.token) {
		//未登陆跳转到根目录页
		next({ path: "/" });
	}else{
		next();
	
	}


})



let href = window.location.hash;
let project_code = href.substring(href.indexOf("#/")+2,href.indexOf("/",2));

setStore(["user", "exam", "project", "answer","config"]);

function setStore(name) {
	
	for (let i in name) {
		if (localStorage.getItem(project_code+'_'+name[i])) {
			store.commit(name[i], JSON.parse(localStorage.getItem(project_code+'_'+name[i])));
		}
	}

}
// 
export default router
